import { getSupabaseClient } from "./supabase";

export interface DayPreplanSnapshotItem {
  project_employee_id?: string;
  employee_name?: string | null;
  presence?: string | null;
  absence_category?: string | null;
  role?: string | null;
  actual_start_time?: string | null;
  actual_end_time?: string | null;
  [key: string]: unknown;
}

export interface DayPreplanSection {
  day_preplan_section_id: string;
  section_type: string;
  mode: "patch" | "replace" | string;
  revision: number;
  snapshot: DayPreplanSnapshotItem[];
  updated_at?: string | null;
}

export interface DayPreplanDate {
  target_date: string;
  sections: DayPreplanSection[];
  day_report_id?: string | null;
  report_status?: string | null;
  report_revision?: number | null;
  staffing_confirmed?: boolean;
}

export async function listFutureDayPreplans(
  projectId: string,
  limit = 100,
): Promise<DayPreplanDate[]> {
  const { data, error } = await getSupabaseClient().rpc("list_day_preplans", {
    target_project_id: projectId,
    target_from_date: null,
    target_limit: limit,
  });

  if (error) {
    throw new Error(error.message || "Voorplanning kon niet worden geladen.");
  }
  return Array.isArray(data) ? data as DayPreplanDate[] : [];
}
